import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { LogMutation, LogMutationVariables } from '@gql/graphql';

export const LOG = graphql(`
  mutation Log($data: LogInput!) {
    log(data: $data)
  }
`);

export interface LogParams {
  content: string;
  params: Record<any, any>;
}

export const useLog = () => {
  const log = (params: LogParams) => {
    const { content, params: logParams } = params;
    logMutation({ variables: { data: { content, params: JSON.stringify(logParams) } } });
  };

  const [logMutation, { error, loading }] = useMutation<LogMutation, LogMutationVariables>(LOG);

  return {
    log,
    logLoading: loading,
    logError: error,
  };
};
